const CONTENT_SYNC_KEY = "mandalis-content-version";
const CONTENT_SYNC_EVENT = "mandalis-content-updated";

export function notifyContentUpdated() {
    if (typeof window === "undefined") return;
    const version = String(Date.now());
    window.localStorage.setItem(CONTENT_SYNC_KEY, version);
    window.dispatchEvent(new CustomEvent(CONTENT_SYNC_EVENT, { detail: version }));
}

export function subscribeContentUpdates(callback) {
    if (typeof window === "undefined") return () => {};
    const onCustom = () => callback();
    const onStorage = (event) => {
        if (event.key === CONTENT_SYNC_KEY) callback();
    };
    window.addEventListener(CONTENT_SYNC_EVENT, onCustom);
    window.addEventListener("storage", onStorage);
    return () => {
        window.removeEventListener(CONTENT_SYNC_EVENT, onCustom);
        window.removeEventListener("storage", onStorage);
    };
}
